import HomeIcon from '@/components/Icons/HomeIcon';
import type { FC } from 'react';

const PropertiesGridEmptyState: FC = () => {
  return (
    <div className="text-center py-12">
      <HomeIcon className="mx-auto h-12 w-12 text-gray-400" />

      <h3 className="mt-2 text-lg font-medium text-gray-900">No floor plans found</h3>
      <p className="mt-1 text-gray-500">Try adjusting your filters to see more results</p>
    </div>
  );
};

export default PropertiesGridEmptyState;
